<template>
  <div class="search-content">
    <div class="search_title" @click="state.selectShow = true">
      <p>
        <img src="../../../assets/nav/yz_nav_ss.png" alt="" />
        {{ state.gamename ? state.gamename : "请输入游戏名称搜索账单 " }}
      </p>
    </div>
    <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <ul
          v-for="(item, i) in state.recordList"
          :key="i + '-list'"
          :border="false"
          v-show="state.showRecord"
        >
          <van-sticky>
            <p class="month-key" @click="state.pickTimeFlag = true">
              {{ item.key }}
              <img src="@/assets/homepage/icon_gamerecord_unfold.png" alt="" />
            </p>
          </van-sticky>
          <li
            v-for="(item2, index) in item.items"
            :class="state.detailList.has(i + '' + index) ? 'record_detail' : ''"
            @click="changeDetail(i, index)"
          >
            <div class="title">
              <span>{{ item2.other }}</span>
              <span>¥{{ item2.amount }}</span>
            </div>
            <div>
              {{ item2.time }}
              <span>{{ item2.paytype }}支付</span>
            </div>
            <div>
              <p>
                <span>订单原价：</span><span>{{ item2.money }}</span>
              </p>
              <p>
                <span>游戏折扣：</span><span>{{ item2.discount * 10 }}折</span>
              </p>
              <p>
                <span>赠送余额抵扣：</span><span>-{{ item2.give_money }}</span>
              </p>
              <p>
                <span>优惠券:</span> <span>-{{ item2.coupon_money }}</span>
              </p>
            </div>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
  </div>

  <van-popup v-model:show="state.pickTimeFlag" round position="bottom">
    <div class="pick_time">
      <van-datetime-picker
        v-model="state.currentDate"
        type="year-month"
        title="选择年月日"
        :min-date="state.minDate"
        :max-date="state.maxDate"
        @confirm="confirmData"
        @cancel="state.pickTimeFlag = false"
      />
    </div>
  </van-popup>

  <van-popup
    v-model:show="state.hideFlag"
    round
    position="bottom"
    :style="{ height: '30%' }"
  >
    <div class="hide_record">
      <h1>是否确认隐藏账单</h1>
      <p>隐藏后如需恢复显示请长按顶部<span>“游戏充值账单”</span></p>
      <button @click="hideRecord()">确认隐藏</button>
      <span>取消</span>
    </div>
  </van-popup>

  <van-popup
    v-model:show="state.selectShow"
    position="bottom"
    round
    :style="{ height: '60%' }"
  >
    <div class="select_game">
      <h1>账单查询</h1>
      <div class="search">
        <van-search
          v-model="state.searchValue"
          show-action
          left-icon=""
          shape="round"
          placeholder="请输入游戏名查询该游戏充值记录"
          @search="onSearch"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>
      <ul>
        <li
          class="community_item"
          v-for="(item, index) in state.selectList"
          :key="index"
          @click="selectGame(item)"
        >
          <div>
            <img :src="item.pic1" alt="" />
            <p>{{ item.gamename }}</p>
          </div>
          <button @click.stop="selectGame(item)">选择</button>
        </li>
      </ul>
    </div>
  </van-popup>
</template>
<script setup>
import { useRouter } from "vue-router";
import { reactive, onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import { monthCardBill } from "@/api/yzuser.js";
import { dateFormat } from "@/utils/date.js";
import { getQueryString } from "@/utils/location.js";
const router = useRouter();
const store = useStore();
const state = reactive({
  pickTimeFlag: false,
  hideFlag: false,
  loading: false,
  finished: false,
  refreshing: true,
  showRecord: true,
  selectShow: false,

  dataMonth: [],
  recordList: [],
  selectList: [],

  detailList: new Set(),
  currentDate: new Date(),
  maxDate: new Date(),
  minDate: new Date(new Date().setMonth(new Date().getMonth() - 6)),
  selectTime: "",
  gid: "",
  gamename: "",
});

onMounted(() => {
  // console.log("进入游戏充值账单页面----", state.maxDate, state.minDate);
});

const onLoad = async () => {
  await getBill();
};

var pagecode = 1;
var totalpage = 1;
const getBill = async () => {
  state.refreshing && (state.loading = false);
  await monthCardBill({
    uid: getQueryString("uid"),
    pagecode: pagecode,
    time: state.selectTime,
    gid: state.gid ? state.gid : "",
  }).then((res) => {
    state.refreshing && (state.refreshing = false);
    if (res.data.code == 1) {
      const monthList = res.data.data.lists;
      const groupedArray = processBillData(monthList);

      // // 合并旧数据和新数据
      state.recordList = mergeRecordLists(state.recordList, groupedArray);
      console.log("账单数据------", state.recordList);
      totalpage = res.data.data.total_page;
      if (pagecode > res.data.data.total_page) {
        state.finished = true;
        return;
      }
      state.loading = false;
    } else {
      Toast(res.data.msg);
      state.finished = true;
    }
  });
  pagecode++;
};

const onRefresh = () => {
  state.selectTime = "";
  state.gid = "";
  state.gamename = "";
  initRecord();
  state.refreshing = true;
  state.loading = false;
  state.selectList = [];
  onLoad();
};

const confirmData = async () => {
  state.selectTime = "";
  state.gid = "";
  state.pickTimeFlag = false;
  initRecord();
  const date = new Date(state.currentDate);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // 月份从0开始，所以需要加1

  state.selectTime = `${year}-${month}`;
  await getBill();
};
// 初始化账单数据
const initRecord = () => {
  pagecode = 1;
  state.recordList = [];
  state.finished = false;
};

// 账单的隐藏和显示
var touchTimer = null;
var touchOccurred = false;
const onTouchStart = (data) => {
  if (state.showRecord) {
    return;
  }
  touchOccurred = false;
  touchTimer = setTimeout(() => {
    state.showRecord = true;
  }, 1000);
};

const onTouchEnd = (data) => {
  //  取消长按事件
  clearTimeout(touchTimer);
};

// 隐藏账单
const hideRecord = () => {
  state.showRecord = false;
  state.hideFlag = false;
};

// 展开账单
const changeDetail = (i, index) => {
  // console.log("展开账单", i + "" + index);
  let data = i + "" + index;
  if (state.detailList.has(data)) {
    state.detailList.delete(data);
  } else {
    state.detailList.add(data);
  }
};

// 搜索游戏
import { toSearchall } from "@/api/gameindex";
import { detect } from "@/utils/device";
const onSearch = async () => {
  console.log("搜索游戏");
  let res = await toSearchall({
    val: state.searchValue,
    type: detect(),
    pagecode: state.pagecode,
  });
  state.selectList = res.data.data.lists;
};
const selectGame = async (item) => {
  state.gamename = item.gamename;
  initRecord();
  state.gid = item.id;
  state.selectShow = false;
  await getBill();
};

// 数据按月分组
const processBillData = (billData) => {
  // 分组逻辑
  const groupDate = billData.reduce((groups, item) => {
    const date = new Date(item.create_time * 1000);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const ym = `${year}年${month}月`;

    // 初始化分组
    if (!groups[ym]) {
      groups[ym] = [];
    }
    groups[ym].push(item);

    return groups;
  }, {});

  // 转换为数组
  return Object.keys(groupDate).map((key) => ({
    key,
    items: groupDate[key],
  }));
};

// 合并数据
const mergeRecordLists = (existingList, newList) => {
  const recordMap = new Map();

  // 将现有的列表存入 Map，使用 key 作为索引
  existingList.forEach((group) => {
    recordMap.set(group.key, [...group.items]);
  });

  // 合并新的列表
  newList.forEach((group) => {
    if (recordMap.has(group.key)) {
      recordMap.set(group.key, recordMap.get(group.key).concat(group.items));
    } else {
      recordMap.set(group.key, [...group.items]);
    }
  });

  // 将 Map 转换为数组
  return Array.from(recordMap.entries()).map(([key, items]) => ({
    key,
    items,
  }));
};
</script>

<style scoped="scoped">
:deep(.van-nav-bar) {
  background-color: #f7f8fa;
}
/* #content {
  background-color: #f7f8fa;
  height: 100vh;
  overflow: hidden;
  padding: 90px 0 50px;
  padding-top: calc(90px + constant(safe-area-inset-top));
  padding-top: calc(90px + env(safe-area-inset-top));
} */
.search-content {
  height: 100vh;
  overflow: auto;
  padding: 20px 32px 200px;
  background-color: #f7f8fa;
  padding-top: 20px;
}
:deep(.van-pull-refresh) {
  overflow: visible;
}
ul .month-key {
  color: #000000;
  margin-bottom: 18px;
  font-weight: 700;
  background-color: #f7f7f7;
}
ul :deep(.van-sticky--fixed) {
  height: 100px !important;
  top: 20px;
}
ul .month-key {
  height: 100%;
  display: flex;
  align-items: center;
}
ul .month-key img {
  width: 18px;
  height: 11px;
  vertical-align: middle;
  margin: 0 0 4px 8px;
}

ul li {
  height: 120px;
  overflow: hidden;
  box-sizing: border-box;
  margin-bottom: 16px;
  background-color: #fff;
  border-radius: 20px;
  padding: 24px;
  transition: all 0.5s ease;
}
.record_detail {
  height: 328px;
}

ul li div {
  display: flex;
  justify-content: space-between;
}

ul li .title {
  font-weight: 500;
  font-size: 28px;
  color: #333;
}

ul .title span:nth-of-type(2) {
  color: #ff3333;
}

ul div:nth-of-type(3) {
  flex-direction: column;
  background-color: #f1f1f1;
}

ul div:nth-of-type(2) {
  margin-bottom: 24px;
  font-size: 24px;
  color: #333;
}

ul div:nth-of-type(3) {
  padding: 20px;
  border-radius: 10px;
}

ul div:nth-of-type(3) p {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  color: #333;
}

ul div:nth-of-type(3) p:nth-of-type(1) span:nth-of-type(2) {
  color: #ff6666;
}

.search_title {
  margin-bottom: 18px;
}
:deep(.van-pull-refresh__head) {
  z-index: -1;
}
.search_title p {
  height: 84px;
  width: 100%;
  background-color: #fff;
  border-radius: 198px;
  display: flex;
  align-items: center;
  padding: 32px;
  font-size: 28px;
  color: #999999;
}
.search_title p img {
  width: 40px;
  height: 40px;
  margin-right: 20px;
}

.hide_record {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 70px 32px 32px;
}
.hide_record h1 {
  font-size: 38px;
  margin-bottom: 38px;
  color: #12cec7;
}
.hide_record button {
  margin: 28px 0;
  width: 380px;
  height: 88px;
  border: none;
  border-radius: 198px;
  background-color: #12cec7;
  color: #fff;
  font-size: 28px;
  font-weight: 700;
}

.select_game {
  height: 100%;
  padding: 40px 32px 0;
}
.select_game h1 {
  font-size: 32px;
  text-align: center;
  line-height: 1;
  margin-bottom: 20px;
}
.select_game ul {
  height: 46vh;
  overflow: auto;
  padding-bottom: 50px;
  margin-top: 24px;
}
.select_game .community_item {
  width: 686px;
  height: 144px;
  background-color: #f4f5f8;
  border-radius: 24px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 24px 22px 32px;
}
.select_game .community_item div {
  display: flex;
  align-items: center;
}
.select_game .community_item div p {
  max-width: 308px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 28px;
  color: #333;
}
.select_game .community_item img {
  width: 100px;
  height: 100px;
  border-radius: 20px;
  margin-right: 20px;
}
.select_game .community_item button {
  width: 104px;
  height: 52px;
  border-radius: 198px;
  border: 2px solid #12cec7;
  color: #12cec7;
  font-size: 20px;
}
</style>
